import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import VinWonderPrice from './../models/VinWonderPrice';

const initialState = {
    isFetching: false,
    isFetched: false,
    vinWonderPrices: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        vinWonderPrice: new VinWonderPrice()
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.VIN_WONDER_PRICE_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_PRICE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                vinWonderPrices: action.vinWonderPrices.result,
                pageSize: action.vinWonderPrices.pageSize,
                pageIndex: action.vinWonderPrices.pageIndex,
                totalCount: action.vinWonderPrices.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.VIN_WONDER_PRICE_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, vinWonderPrices: [] };
        case Types.VIN_WONDER_PRICE_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.VIN_WONDER_PRICE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    vinWonderPrice: action.vinWonderPrice
                }
            };
        case Types.VIN_WONDER_PRICE_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.VIN_WONDER_PRICE_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_PRICE_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_PRICE_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_PRICE_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default: 
            return state
    }
}
